/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SECTION_OPTION } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IInventoryMethods extends IPluginMethodMap {
  getInventoryProps(args: any): Promise<any>;
}

export class InventoryService implements IAgentPlugin {
  readonly methods: IInventoryMethods;

  constructor() {
    this.methods = {
      getInventoryProps: this.getInventoryProps.bind(this),
    };
  }

  async getInventoryProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log("getInventoryProps args ->", args);

    const filters: any = {};

    if (args?.presentation) {
      filters.presentation = {
        eq: args.presentation,
      };
    }

    if (args?.isCommon !== undefined) {
      filters.isCommon = args.isCommon === true ? { eq: true } : { eq: false };
    }

    if (args?.commonSearch) {
      filters.commonSearch = args.commonSearch;
    }

    const costumeTypeId = args?.costumeType || args?.id;

    if (costumeTypeId) {
      filters.costumeType = {
        eq: costumeTypeId,
      };
    }

    const sectionId = args?.section || args?.fid;

    if (sectionId) {
      filters.section = {
        eq: sectionId,
      };
    }

    if (args?.vid === true) {
      args.vid = "-";
    }

    if (args?.vid && args?.vid !== "-") {
      filters.CV___name = {
        eq: args.vid,
      };
    }

    if (args?.att && args?.att !== "-") {
      filters.CA___name = {
        eq: args.att,
      };
    }

    try {
      if (client) {
        const res = await client.query({
          query: GET_SECTION_OPTION,
          variables: {
            filters,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
              sort: {
                field: "name",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          const report = res?.data?.getFullCostumeFeatureInventories;

          const content = report?.content || [];

          const limit = args?.size ?? 10;

          const totalPages = report?.count
            ? Math.ceil(parseInt(report.count) / limit)
            : 1;

          const currentPage =
            report?.limit && report?.skip !== undefined
              ? Math.floor(report.skip / report.limit) + 1
              : 1;

          const rowData = this.formatTable(content, args?.fid);

          return {
            ...config,

            /*
             * Return the presentation received from the
             * container so the UI can retain it as default.
             */
            defaultPresentation: args?.presentation || "",

            ultUsers: rowData,
            isEmpty: rowData.length <= 0,
            activePage: currentPage,

            pageSize: report?.limit ?? limit,

            totalCount: report?.count ?? 0,

            totalPages,

            ...this.breadcrumbItems(content),
          };
        }
      }
    } catch (err: any) {
      console.log("error in table data", err);

      return {
        ...config,
        defaultPresentation: args?.presentation || "",
        ultUsers: [],
        isEmpty: true,
        activePage: 1,
        pageSize: args?.size ?? 10,
        totalCount: 0,
        totalPages: 1,
      };
    }

    return {
      ...config,
      defaultPresentation: args?.presentation || "",
      ultUsers: [],
      isEmpty: true,
      activePage: 1,
      pageSize: args?.size ?? 10,
      totalCount: 0,
      totalPages: 1,
    };
  }
  private breadcrumbItems(costumeFeatures: any[]) {
    let data = {
      section: "",
      sectionOption: "",
      presentation: "",
    };
    if (costumeFeatures?.length > 0) {
      data.section = costumeFeatures[0]?.section?.name;
      data.sectionOption = costumeFeatures[0]?.costumeType?.name;
      data.presentation = costumeFeatures[0]?.presentation?.name;
    }
    return data;
  }

  private formatTable(costumeFeatures: any[], fid?: any): any[] {
    let _rowData: any = [];
    costumeFeatures?.forEach((item) => {
      console.log("data item==>", item?.CA?.name);
      _rowData.push({
        historyArray: item?.History,
        valueName: `${item?.CV?.name ?? "-"}`,
        id: item?.CV.id ?? "-",
        featureName: item.name ?? "-",
        attributeName: item?.CA?.name ?? "-",
        inventory: item?.CVInventory ?? 0,
        featureId: item.id,
        registered: item.registered ?? 0,
        remaining: item.remaining ?? 0,
      });
    });
    return _rowData;
  }
}
